import React, { useContext } from 'react';

import { ProductsContext } from 'context/ProductsContext';

import './style.scss';

export default function Filter() {
  const { setItemKeyword, filterItems, setFilterItems } = useContext(ProductsContext);


  const updateItems = (item) => {
    const uItems = filterItems.map(fitem => fitem.category === item.category ? { ...fitem, active: !fitem.active } : { ...fitem, active: false });
    setFilterItems(uItems);
  }


  const toggleFilter = (item) => {
    let active = !item.active;

    if (active) {
      setItemKeyword(item.category);
      updateItems(item);
    }

    if (!active) {
      setItemKeyword('');
      updateItems(item);
    }

  }

  const fixCategorySpelling = (cgory) => {
    const ourCategory = cgory;
    const capCategory = ourCategory.charAt(0).toUpperCase() + ourCategory.slice(1);
    
    return capCategory.endsWith("s") ? capCategory : capCategory + 's';
  }

  return (
    <div className="filterWrap">
      {
        filterItems.map(item => <button
          onClick={() => toggleFilter(item)}
        >
          <h6 className={item.active ? 'active' : null}>{fixCategorySpelling(item.category)}</h6>
        </button>)
      }
    </div>
  );
}
